import React from "react";
import styled from "@emotion/styled";
import EditorAddIcon from "@atlaskit/icon/glyph/editor/add";

import { Grid } from "../../UI/Grid";
import { Button } from "../../UI/Button";
import { EnhancedTable } from "../EnhancedTable";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";

import { SelectQuestionsTableHead } from "./SelectQuestionsTableHead";
import { SelectQuestionsTableBody } from "./SelectQuestionsTableBody";

import { QUESTIONS_LIMIT } from "../../constants/general";
import { SelectQuestionModal } from "../SelectQuestionModal";
import useAuth from "../../routes/login/AuthContext";

export interface IProps {
  questions: any[];
  isLoading?: boolean;
  onReorder: (data: any) => void;
  onSave: (data: any) => void;
  onRemove: (data: any) => void;
  showTagColumn?: any;
  editDisabled: boolean;
}

const StyledAddButton = styled(Button)`
  height: 40px;
`;

export const SelectQuestionsTable: React.FC<IProps> = (props) => {
  const { isSuperAdminRead } = useAuth();
  const [data, setData] = React.useState<Record<string, any> | boolean>(false);

  const openQuestionHandler = () => setData(true);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <EnhancedTable title="Select Questions">
            <SelectQuestionsTableHead showTagColumn={props.showTagColumn} />
            <SelectQuestionsTableBody setData={setData} {...props}/>
          </EnhancedTable>
        </Grid>
        {props.questions.length <= QUESTIONS_LIMIT && (
          <Grid item xs={12}>
            <ReadOnlyWrapper>
              <StyledAddButton
                isDisabled={isSuperAdminRead() || props.editDisabled}
                appearance="primary"
                iconBefore={<EditorAddIcon label="Plus" />}
                onClick={openQuestionHandler}
              >
                Add a Select Question
              </StyledAddButton>
            </ReadOnlyWrapper>
          </Grid>
        )}
      </Grid>
      <SelectQuestionModal data={data} onHide={setData} onSave={props.onSave} showTagColumn={props.showTagColumn} />
    </>
  );
};
